import React, { memo, useState, useRef, useEffect, useCallback } from 'react';
import { useThrottleFn } from 'ahooks';
import SwiperIcon from './SwiperIcon';
import './index.scss';

interface JumperBtnPropsTypes {
  dataLen: number; // 总共显示多少个数据
  lineNum?: number; // 显示多少行
  itemWidth?: number; // 每个元素占的宽度
  minimumColMargin?: number; // 元素间最小的列间距
  // 页码，页长，每页显示个数发生变化时触发
  onChange:
    | ((pageMessage: {
        pageIndex: number;
        pageSize: number;
        lineCount: number;
        showCount: number;
        containerWidth: number;
      }) => void)
    | null;
  [keyName: string]: any;
}

export default function Swiper(props: JumperBtnPropsTypes) {
  const {
    dataLen,
    lineNum = 2,
    itemWidth = 330,
    minimumColMargin = 20,
    onChange,
    children,
  } = props;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const jumperBtnRef = useRef<HTMLElement>(null);

  const getShowParams = (
    _dataLen: number,
    _lineNum: number,
    _itemWidth: number,
    _minimumColMargin: number,
    _throttleContainerWidth: number,
  ) => {
    let pageSize = 1;
    let showCount = 0;
    let lineCount = 0;
    for (let i = 0; i < 30; i++) {
      // 最多循环30次
      const currentWidth = (i + 1) * (_itemWidth + _minimumColMargin) - _minimumColMargin;
      if (currentWidth > _throttleContainerWidth) {
        lineCount = i > 0 ? i : 1;
        break;
      }
    }
    showCount = lineCount * _lineNum;
    pageSize = Math?.ceil(_dataLen / showCount);
    return {
      pageSize, // 总共多少页
      lineCount, // 一行显示的个数
      showCount, // 一页显示多少个
    };
  };

  const change = (action?: any) => {
    const { pageIndex: _pageIndex } = action || {};
    if (jumperBtnRef?.current) {
      // const addedWidth = 40;
      const _width = jumperBtnRef?.current?.clientWidth;
      const { pageSize, lineCount, showCount } = getShowParams(
        dataLen,
        lineNum,
        itemWidth,
        minimumColMargin,
        _width,
      );
      setPageSize(pageSize);
      onChange?.({
        pageIndex: _pageIndex || pageIndex,
        pageSize,
        lineCount,
        showCount,
        containerWidth: _width,
      });
    }
  };

  const { run: handleResizeRun } = useThrottleFn(
    () => {
      setPageIndex(1);
      change({ pageIndex: 1 });
    },
    {
      leading: true,
      trailing: true,
    },
  );

  const handleIconClick = (type: string) => {
    if (type === 'prev' && pageIndex === 1) return;
    if (type === 'next' && pageIndex === pageSize) return;
    const currentpage = type === 'prev' ? pageIndex - 1 : pageIndex + 1;
    setPageIndex(currentpage);
    change({
      pageIndex: currentpage,
    });
  };

  // 添加视口监听及获取初始容器宽度（按钮容器宽度）
  useEffect(() => {
    handleResizeRun();

    window.addEventListener('resize', handleResizeRun);

    return () => {
      window.removeEventListener('resize', handleResizeRun);
    };
  }, [dataLen]);

  return (
    <section className="dbi-swiper-wrap" ref={jumperBtnRef}>
      {pageSize !== 1 && (
        <SwiperIcon type="prev" disabled={pageIndex === 1} handleIconClick={handleIconClick} />
      )}
      {children}
      {pageSize !== 1 && (
        <SwiperIcon
          type="next"
          disabled={pageIndex === pageSize}
          handleIconClick={handleIconClick}
        />
      )}
    </section>
  );
}
